module.exports = __webpack_public_path__ + "img/59.c2b13fed.jpg";